// extracted by css-extract-rspack-plugin
export default {"shortcut":"BU2Zo471xSQmvf1b","then":"mynDa0UKx6QOSCC4","key":"BMzMsZd2XxE11EyZ"};